import React from 'react';
import { Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { faHome } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ROUTER_BASE_PATH } from '../../constants/siteConstants';

const HomeButton = () => {
  return (
    <Button className='btn btn-sm btn-dark'>
      <Link to={`/`}>
        <FontAwesomeIcon className='text-white fs-' icon={faHome}></FontAwesomeIcon>
      </Link>
    </Button>
  );
};

export default HomeButton;
